<mg-auth-wrapper *ngIf="acc">
  <div
    *ngIf="acc"
    class="d-flex w-100 align-items-stretch justify-content-start"
  >
    <div class="col-12 col-lg-6 bg-white py-5">
      <div
        class="d-flex col-md-3 justify-content-center"
        *ngIf="RolesCanSeeUserManager()"
      >
        <a routerLink="/system-setting">
          <p class="text-line">
            <span class="aya-sliders text-primary"></span> الإعدادت والمستخدمين
          </p>
        </a>
      </div>
      <div class="d-flex h-100 align-items-center justify-content-center">
        <div class="">
          <div class="mb-4 mx-auto text-center">
            <img height="70" class="mb-5" [src]="logos.ryadGreen" alt="" />

            <h2 class="text-primary fw-bold mb-3">
              وكالة الامتثال و الاستدامة البيئية
            </h2>
            <div class="w-100 text-center text-body mb-3 mb-md-5">
              <p class="mb-0 text-primary">
                <span class="bx bx-user-check fs-5 align-middle"></span>
                <span class="">
                  {{ acc.fullName || acc.email }}
                </span>
              </p>
              <p class="mb-0 text-primary">
                <span class="bx bx-building fs-5 align-middle"></span>

                <span class="">
                  {{ acc.stackholder?.stackholder_Name }}
                </span>
              </p>
              <p class="mb-0">فضلاً قم باختيار النظام</p>
            </div>
          </div>
          <ng-container *ngFor="let system of systemsParent">
            <div class="systems_body">
              <ng-container>
                <a
                  *appRole="system.roles || []"
                  [href]="system.link"
                  class="system_selector mb-3"
                >
                  <span>
                    <img [src]="system?.logo" alt="" />
                  </span>
                  <h5 class="mb-0">
                    {{ system?.name }}
                  </h5>
                </a>
              </ng-container>
            </div>
          </ng-container>
          <div ngbAccordion #accordion="ngbAccordion">
            <div ngbAccordionItem="first">
              <h2>
                <button
                  class="btn btn-link text-decoration-none d-flex justify-content-between align-items-center"
                  ngbAccordionButton
                >
                  <div>
                    <div>
                      <h5 class="mb-0">
                        <i class="aya-cube fs-5 align-middle me-2"></i>
                        أنظمة أخرى
                      </h5>
                    </div>
                  </div>
                  <i class="aya-chevron-down float-end"></i>
                </button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <ng-container *ngFor="let system of systems">
                      <div class="systems_body">
                        <!-- ?? Systems -->

                        <ng-container>
                          <a
                            *appRole="system.roles || []"
                            [href]="system.link"
                            class="system_selector mb-3"
                          >
                            <span>
                              <img [src]="system?.logo" alt="" />
                            </span>
                            <h5 class="mb-0">
                              {{ system?.name }}
                            </h5>
                          </a>
                        </ng-container>
                      </div>
                    </ng-container>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>

          <!-- <hr /> -->

          <!-- <ng-container *ngFor="let system of systems">
            <div [ngClass]="{'other-show': system.other===1 || system.other ===2, 'other-hide': system.other===3}"
              class="systems_body">

              <ng-container>


                <a *appRole="system.roles || []" [href]="system.link"
                   class="system_selector mb-3">
                  <span>
                    <img [src]="system?.logo" alt="">

                  </span>
                  <h5 class="mb-0">
                    {{system?.name}}
                  </h5>

                </a>
              </ng-container>


            </div>
          </ng-container> -->
          <div class="mt-4 text-center">
            <a
              (click)="logout()"
              class="btn btn-link btn-sm text-danger"
              role="button"
            >
              <span class="aya-power-on"></span>
              تسجيل الخروج
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</mg-auth-wrapper>
<!-- end container -->

<!--

       <div [ngClass]="{'other-show': system.other===1 || system.other ===2, 'other-hide': system.other===3}"
              class="systems_body" (click)="toggleOther(system)">
              ?? Systems

              <ng-container>


                <a *appRole="system.roles || []" [href]="system.link" class="system_selector mb-3">
                  <span>
                    <img [src]="system?.logo" alt="">

                  </span>
                  <h5 class="mb-0">
                    {{system?.name}}
                  </h5>

                </a>
              </ng-container>


            </div>
 -->
